/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import { ExternalContacts } from "../components/ExternalContacts";
import { ExternalContactsProvider } from "../context/externalContacts";
import { ShowSnackbar } from "../../../components/Common";

/**
 * Page used to manage external contacts.
 * Contains functionality to create, edit, delete, export and import contacts.
 */
const ExternalContactsPage = () => {
	const [notification, setNotification] = React.useState({ message: "", severity: "success" });

	const handleSnackBarClose = () => {
		setNotification((cur) => ({ ...cur, message: "" }));
	};

	const setSnackbar = React.useCallback((message, severity) => {
		setNotification({ message, severity });
	}, []);

	return (
		<div style={{ width: "100%", marginTop: 30 }}>
			<ShowSnackbar message={notification.message} severity={notification.severity} onClose={handleSnackBarClose} />
			<ExternalContactsProvider showSnackbar={setSnackbar}>
				<ExternalContacts />
			</ExternalContactsProvider>
		</div>
	);
};

export default ExternalContactsPage;
